import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NCheckoutFormCms } from './checkout-form-cms.component';
@Injectable({ providedIn: 'root' })
export class CheckoutFormCmsResolver implements Resolve<void | ICmsBlock<NCheckoutFormCms.IBlockData>> {
    constructor(private iCmsBlockResource: ICmsBlockResource) { }
    resolve(): Promise<void | ICmsBlock<NCheckoutFormCms.IBlockData>> {
        return this.iCmsBlockResource.retrieve({ bareUrl: NCheckoutFormCms.BLOCK_ID }, undefined);
    }
}
